module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/id-8753396183d5bfde6deb68db90455b31.jpg";